//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteBlockTextAndMediaImageInputItem } from './WebsiteBlockTextAndMediaImageInputItem';
import { WebsiteCustomFieldContactFormInputItem } from './WebsiteCustomFieldContactFormInputItem';
import { WebsiteBlockUpdateItem } from './WebsiteBlockUpdateItem';
import { WebsiteBlockContactFormType, WebsiteBlockType } from './Enums';

export class WebsiteBlockContactFormUpdateItem extends WebsiteBlockUpdateItem {
    Header?: string | null;
    Body?: string | null;
    Images?: WebsiteBlockTextAndMediaImageInputItem[];
    ThankYouMessage?: string | null;
    ContactFormType: WebsiteBlockContactFormType = WebsiteBlockContactFormType.Default;
    override readonly WebsiteBlockType: WebsiteBlockType = WebsiteBlockType.ContactForm;
    CustomFields?: WebsiteCustomFieldContactFormInputItem[];

    constructor(initializer?: Partial<Omit<WebsiteBlockContactFormUpdateItem, "WebsiteBlockType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockContactFormUpdateItem";
}
